import React from 'react';
import { Box, Typography } from '@ublend-npm/aulaui-core';
import StudentRow from '../../components/StudentRow';
import {
  ExtensionStudent,
  ManageExtensionStyles,
} from './ManageExtension.types';

type Props = {
  onToggleStudent: (studentId: string) => void;
  selectedIds: string[];
  students: ExtensionStudent[];
  styles: ManageExtensionStyles;
};

const CohortStudentsList = ({
  onToggleStudent,
  selectedIds,
  students,
  styles,
}: Props) => {
  const addedStudents = students.filter(({ id }) => selectedIds.includes(id));
  const notAddedStudents = students.filter(
    ({ id }) => !selectedIds.includes(id)
  );
  const orderedStudents = [...addedStudents, ...notAddedStudents];
  const remainingStudents = notAddedStudents.length;
  const label = `(${remainingStudents})`;
  return (
    <Box sx={styles.studentsStep}>
      <Typography component="h3" sx={styles.cohortTitle}>
        Main cohort {remainingStudents > 0 && label}
      </Typography>
      <Box component="ul" sx={styles.studentList}>
        {orderedStudents.map((student) => {
          const isSelected = selectedIds.includes(student.id);

          return (
            <StudentRow
              key={student.id}
              canAdd
              isDimmed={isSelected}
              isSelected={isSelected}
              onToggle={onToggleStudent}
              showAction={!isSelected}
              student={student}
            />
          );
        })}
      </Box>
    </Box>
  );
};

export default CohortStudentsList;
